// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import shortid from "shortid";
import { StorageProviderFactory, IStorageProvider } from "../providers/storage/storageProviderFactory";
import {
    IProject, ITag, ISecurityToken, AppError,
    ErrorCode,
    FieldType,
    FieldFormat,
    IField,
    IFieldInfo,ModelPathType,IActiveLearningSettings,IAzureCVExportFields
} from "../models/applicationState";
import {
    LoadUserFilesEndPointBasedOnModel, analysisGetEndPoint, headers,LoadUserFilesforQueueEndPoint,
    generateOcrEndPoint, ocrForIndividualFile, createModelEndPoint, accessToken, refreshTokenEndPoint,
     refreshTokenCall,LoadUserFilesEndPointBasedOnModel_Chep
} from "../common/api-config";
import ServiceHelper from "./serviceHelper";
import Guard from "../common/guard";
import { constants } from "../common/constants";
import { decryptProject, encryptProject, joinPath, patch, getNextColor } from "../common/utils";
import packageJson from "../../package.json";
import { strings, interpolate } from "../common/strings";
import { toast } from "react-toastify";
import { ExportProviderFactory } from "../providers/export/exportProviderFactory";

import { ExportAssetState } from "../providers/export/exportProvider";
import { IExportFormat } from "vott-react";
import {AzureCustomVisionProvider,NewOrExisting,AzureRegion,IAzureCustomVisionExportOptions}  from "../providers/export/azureCustomVision";
 
// tslint:disable-next-line:no-var-requires
const tagColors = require("../react/components/common/tagColors.json");

/**
 * Functions required for a project service
 * @member save - Save a project
 * @member delete - Delete a project
 */
export interface IProjectService {
    loadAllFilesFromBlob(modelName: string, keyword: string): Promise<void>;
    load(project: IProject, securityToken: ISecurityToken): Promise<IProject>;
    save(project: IProject, securityToken: ISecurityToken, saveTags?: boolean,
        updateTagsFromFiles?: boolean): Promise<IProject>;
    delete(project: IProject): Promise<void>;
    generateOcr(projectName: string, fileName: string): Promise<void>;
    isDuplicate(project: IProject, projectList: IProject[]): boolean;
    updateProjectTagsFromFiles(oldProject: IProject, asset?: string): Promise<IProject>;
    updateProjectTagsFromExistingLabelFile(oldProject: IProject, asset?: string): Promise<IProject>;
    getAnalyseResultData(modelName: string, analysis: string): Promise<void>;
    createModelName(modelData: any): Promise<void>;
    getOcrForIndividualFile(fileObject: any): Promise<void>;

    loadAllFilesFromOpBlob(modelName: string): Promise<void>;
}



const defaultActiveLearningSettings: IActiveLearningSettings = {
    autoDetect: false,
    predictTag: true,
    modelPathType: ModelPathType.Coco,
};

/*
const defaultExportOptions: IExportFormat = {
    providerType: "vottJson",
    providerOptions: {
        assetState: ExportAssetState.Visited,
        includeImages: true,
    },
};
*/

//new start
//const  providerType = "azureCustomVision";
const azureexportOptions : IAzureCustomVisionExportOptions ={
    assetState: ExportAssetState.Visited,
    newOrExisting: NewOrExisting.New,
   // region: AzureRegion.EastUS2,
    //apiKey: "8c8eef4257f0401fa0a50064bf00d79d",
   // region: AzureRegion.EastUS,
    //apiKey: "7d70a928b45c4ee184f9dee2b1b33e9d",

    // region: AzureRegion.EastUS2,
   // apiKey: "8b8ba0c2da2046e08a3110281f35f0a5",
   // apiKey : "fad20d4906df4906afa20cccfd969fe5",
 //  apiKey : "1d0f5d93322c49438e3c6b351bfec8a8",
    projectId: "",
    name:  "",
    description: "project export",
   // projectType: "ObjectDetection",
    classificationType: "Multilabel",
   // domainId: "da2e3a8a-40a5-4171-82f4-58522f70fbc1",
  // domainId: "b4ccfcd8-3333-4b8f-a3ce-813378a34fb1",
  //domainId: "fa7fc6ed-a9f4-4292-960d-c393aed9f427",
  region: AzureRegion.EastUS,
 // apiKey : "7d70a928b45c4ee184f9dee2b1b33e9d",             
 // domainId: "da2e3a8a-40a5-4171-82f4-58522f70fbc1",
 apiKey :IAzureCVExportFields.apiKey,
 domainId:IAzureCVExportFields.domainId,
    includeImages: true,
   };
   
   const defaultExportOptions: IExportFormat = {
    providerType:"azureCustomVision",
    providerOptions:  azureexportOptions
   };
/*
const defaultExportOptions: IExportFormat = {
    providerType: "vottJson",
    providerOptions: {
        assetState: ExportAssetState.Visited,
        includeImages: true,
    },
};*/

//new end
/**
 * @name - Project Service
 * @description - Functions for dealing with projects
 */
export default class ProjectService implements IProjectService {
    /**
     * Loads a project
     * @param project The project JSON to load
     * @param securityToken The security token used to decrypt sensitive project settings
     */
    public async load(project: IProject, securityToken: ISecurityToken): Promise<IProject> {
        Guard.null(project);

        try {
            const loadedProject = await decryptProject(project, securityToken);

            // Ensure tags is always initialized to an array
            if (!loadedProject.tags) {
                loadedProject.tags = [];
            }


             //

            // Initialize active learning settings if they don't exist
            if (!loadedProject.activeLearningSettings) {
                loadedProject.activeLearningSettings = defaultActiveLearningSettings;
            }

            // Initialize export settings if they don't exist
            if (!loadedProject.exportFormat) {
                loadedProject.exportFormat = defaultExportOptions;
            }

            this.ensureBackwardsCompatibility(loadedProject);

            //

            return Promise.resolve({ ...loadedProject });
        } catch (e) {
            const error = new AppError(ErrorCode.ProjectInvalidSecurityToken, "Error decrypting project settings");
            return Promise.reject(error);
        }
    }

    /**
     * Save a project
     * @param project - Project to save
     * @param securityToken - Security Token to encrypt
     */
    public async save(project: IProject, securityToken: ISecurityToken, saveTags?: boolean,
        updateTagsFromFiles?: boolean): Promise<IProject> {
        Guard.null(project);

        project.version = packageJson.version;

        if (!project.id) {
            project.id = shortid.generate();
        }

          //

        // Initialize active learning settings if they don't exist
        if (!project.activeLearningSettings) {
            project.activeLearningSettings = defaultActiveLearningSettings;
        }



        // Initialize export settings if they don't exist
        
        if (!project.exportFormat) {
            project.exportFormat = defaultExportOptions;
        }
        


        //
        const storageProvider = await StorageProviderFactory.createFromConnection(project.sourceConnection);

        if (updateTagsFromFiles) {
            project = await this.updateProjectTagsFromFiles(project, "updateTag");
        }

        if (project.tags && saveTags) {
            await this.saveFieldsFile(project, storageProvider);
        }

        project = await encryptProject(project, securityToken);

        // await storageProvider.writeText(
        //     `${project.name}${constants.projectFileExtension}`,
        //     JSON.stringify(project, null, 4),
        // );

        return project;
    }

    /**
     * Delete a project
     * @param project - Project to delete
     */
    public async delete(project: IProject): Promise<void> {
        Guard.null(project);

        const storageProvider = StorageProviderFactory.createFromConnection(project.sourceConnection);

        try {
            // try deleting project file
            await storageProvider.deleteFile(`${project.name}${constants.projectFileExtension}`);
            toast.info(interpolate(strings.homePage.messages.deleteSuccess, { project }));
        } catch (error) {
            let reason = "";
            if (error.errorCode === ErrorCode.BlobContainerIOForbidden) {
                reason = interpolate(strings.errors.projectDeleteForbidden.message, { file: `${project.name}${constants.projectFileExtension}` });
            } else if (error.errorCode === ErrorCode.BlobContainerIONotFound) {
                reason = interpolate(strings.errors.projectDeleteNotFound.message, { file: `${project.name}${constants.projectFileExtension}` });
            } else {
                reason = strings.errors.projectDeleteError.message;
            }
            toast.error(reason, { autoClose: false });
        }
    }

    /**
     * Checks whether or not the project would cause a duplicate at the target connection
     * @param project The project to validate
     * @param projectList The list of known projects
     */
    public isDuplicate(project: IProject, projectList: IProject[]): boolean {
        const duplicateProjects = projectList.find((p) =>
            p.id !== project.id &&
            p.name === project.name &&
            JSON.stringify(p.sourceConnection.providerOptions) ===
            JSON.stringify(project.sourceConnection.providerOptions),
        );
        return (duplicateProjects !== undefined);
    }

    public async isProjectNameAlreadyUsed(project: IProject): Promise<boolean> {
        const storageProvider = StorageProviderFactory.createFromConnection(project.sourceConnection);
        const fileList = await storageProvider.listFiles(null/*folderPath*/, constants.projectFileExtension/*ext*/);
        for (const fileName of fileList) {
            if (fileName === `${project.name}${constants.projectFileExtension}`) {
                return true;
            }
        }

        return false;
    }

    public async updateProjectTagsFromFiles(project: IProject, asset?: string): Promise<IProject> {
        const updatedProject = Object.assign({}, project);
        updatedProject.tags = [];
        updatedProject.tableTags = [];
        const storageProvider = StorageProviderFactory.createFromConnection(project.sourceConnection);
        await this.getTagsFromPreExistingFieldFile(updatedProject, storageProvider);
        // if (asset) {
        // await this.getTagsFromPreExistingLabelFiles(updatedProject, storageProvider, asset);
        // await this.setColorsForUpdatedTags(project, updatedProject);
        // }
        return updatedProject;
    }

    public async updateProjectTagsFromExistingLabelFile(project: IProject, asset?: string): Promise<IProject> {
        const updatedProject = Object.assign({}, project);
        const storageProvider = StorageProviderFactory.createFromConnection(project.sourceConnection);
        await this.getTagsFromPreExistingLabelFiles(updatedProject, storageProvider, asset);
        await this.setColorsForUpdatedTags(project, updatedProject);
        return updatedProject;
    } 

    /**
     * Create a Models
     */
    public createModelName = async (modelObject: any) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                createModelEndPoint(modelObject), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            createModelEndPoint(modelObject), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Generate OCR
     */

    public generateOcr = async (projectName: string, fileName: string) => {
        let response;
        let headers = accessToken()
        const body = {
            project_name: projectName,
            file_name: fileName,
        }
        try {
            response = await ServiceHelper.postWithAutoRetry(
                generateOcrEndPoint(projectName, fileName), body, { headers });
            let ocrResponse;
            ocrResponse = response.data.ocr;
            ocrResponse["id"] = shortid();
            ocrResponse["fileName"] = fileName;
            return ocrResponse;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            generateOcrEndPoint(projectName, fileName), body, { headers });
                        let ocrResponse;
                        ocrResponse = response.data.ocr;
                        ocrResponse["id"] = shortid();
                        ocrResponse["fileName"] = fileName;
                        return ocrResponse;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }


    public loadAllFilesFromBlob = async (modelName: string, keyword: string) => {
        let response;
        let headers = accessToken()
        try {
            if(keyword === "OPtesting")
            {
                response = await ServiceHelper.getWithAutoRetry(
                    LoadUserFilesforQueueEndPoint(modelName), { headers });
    
            }
            else if(keyword === "FailedProcess")
            {
                response = await ServiceHelper.getWithAutoRetry(
                    LoadUserFilesEndPointBasedOnModel(modelName,"training"), { headers });
    
            }
            else if(keyword === "invtraining")
            {
                //LoadUserFilesEndPointBasedOnModel_Chep
                response = await ServiceHelper.getWithAutoRetry(
                    LoadUserFilesEndPointBasedOnModel_Chep(modelName, keyword), { headers });

          //  response = await ServiceHelper.getWithAutoRetry(
          //      LoadUserFilesEndPointBasedOnModel(modelName, keyword), { headers });
            }
            else
            {
                //LoadUserFilesEndPointBasedOnModel_Chep
                //response = await ServiceHelper.getWithAutoRetry(
                 //   LoadUserFilesEndPointBasedOnModel_Chep(modelName, keyword), { headers });

            response = await ServiceHelper.getWithAutoRetry(
              LoadUserFilesEndPointBasedOnModel(modelName, keyword), { headers });
            }
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            LoadUserFilesEndPointBasedOnModel(modelName, keyword), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    
    public loadAllFilesFromOpBlob = async (modelName: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                LoadUserFilesforQueueEndPoint(modelName), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            LoadUserFilesforQueueEndPoint(modelName), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }


    public getOcrForIndividualFile = async (fileObject: any) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                ocrForIndividualFile(fileObject), { headers });
            let ocrResponse;
            if (response.data.length > 0) {
                ocrResponse = response.data[0].ocr_content;
                ocrResponse["id"] = shortid();
                ocrResponse["fileName"] = fileObject.file_name;
            }
            return ocrResponse;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            ocrForIndividualFile(fileObject), { headers });
                        let ocrResponse;
                        if (response.data.length > 0) {
                            ocrResponse = response.data[0].ocr_content;
                            ocrResponse["id"] = shortid();
                            ocrResponse["fileName"] = fileObject.file_name;
                        }
                        return ocrResponse;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }


    public getAnalyseResultData = async (modelName: string, analysis: string) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.getWithAutoRetry(
                analysisGetEndPoint(modelName, analysis), { headers });
            return response.data;
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            analysisGetEndPoint(modelName, analysis), { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Assign project tags.
     * A new project doesn't have any tags at the beginning. But it could connect to a blob container
     * which contains existing label files. In this case, we'll populate project tags based on these files.
     * @param project the project we're trying to create
     * @param storageProvider the storage we're trying to save the project to
     * @param asset the asset to get tags from
   */
    private async getTagsFromPreExistingLabelFile(
        project: IProject,
        storageProvider: IStorageProvider,
        asset?: string) {
        const tags: ITag[] = [];
        const tagNameSet = new Set<string>();
        try {
            const blobs = new Set<string>(await storageProvider.listFiles());
            const assetLabel = asset ? asset + constants.labelFileExtension : undefined;
            for (const blob of blobs) {
                const blobFolderPath = blob.substr(0, blob.lastIndexOf("/"));
                if (blobFolderPath === project.folderPath
                    && blob.endsWith(constants.labelFileExtension)
                    && blobs.has(blob.substr(0, blob.length - constants.labelFileExtension.length))) {
                    try {
                        if (!assetLabel || assetLabel === blob) {
                            const content = JSON.parse(await storageProvider.readText(blob));
                            content.labels.forEach((label) => tagNameSet.add(label.label));
                        }
                        if (assetLabel && assetLabel === blob) {
                            break;
                        }
                    } catch (err) {
                        // ignore err
                    }
                }
            }
            const tagNameArray = Array.from(tagNameSet);
            if (tagNameArray.containsDuplicates((name) => name)) {
                const reason = interpolate(
                    strings.errors.duplicateFieldKeyInLabelsFile.message,
                    { labelFileName: strings.projectService.existingLabelFiles });
                toast.error(reason, { autoClose: false });
                throw new Error("Invalid label file");
            }
            tagNameArray.forEach((name, index) => {
                tags.push({
                    name,
                    color: tagColors[index],
                    // use default type
                    type: FieldType.String,
                    format: FieldFormat.NotSpecified,
                } as ITag);
            });
            if (project.tags) {
                await this.addMissingTags(project, tags);
            } else {
                project.tags = tags;
            }
        } catch (err) {
            // ignore err
        }
    }

    /**
     * Assign project tags.
     * A new project doesn't have any tags at the beginning. But it could connect to a blob container
     * which contains existing label files. In this case, we'll populate project tags based on these files.
     * @param project the project we're trying to create
     * @param storageProvider the storage we're trying to save the project to
     * @param asset the asset to get tags from
     */
    private async getTagsFromPreExistingLabelFiles(
        project: IProject,
        storageProvider: IStorageProvider,
        asset?: string) {
        const tags: ITag[] = [];
        const tagNameSet = new Set<string>();
        try {
            const blobs = new Set<string>(await storageProvider.listFiles());
            // const assetLabel = asset ? asset + constants.labelFileExtension : undefined;
            const assetLabel = asset ? asset : undefined;
            for (const blob of blobs) {
                const blobFolderPath = blob.substr(0, blob.lastIndexOf("/"));
                if (blobFolderPath === project.folderPath
                    && blob.endsWith(constants.labelFileExtension)
                    && blobs.has(blob.substr(0, blob.length - constants.labelFileExtension.length))) {
                    try {
                        if (!assetLabel || assetLabel === blob) {
                            const content = JSON.parse(await storageProvider.readText(blob));
                            content.labels.forEach((label) => tagNameSet.add(label.label));
                        }
                        if (assetLabel && assetLabel === blob) {
                            break;
                        }
                    } catch (err) {
                        // ignore err
                    }
                }
            }
            const tagNameArray = Array.from(tagNameSet);
            if (tagNameArray.containsDuplicates((name) => name)) {
                const reason = interpolate(
                    strings.errors.duplicateFieldKeyInLabelsFile.message,
                    { labelFileName: strings.projectService.existingLabelFiles });
                toast.error(reason, { autoClose: false });
                throw new Error("Invalid label file");
            }
            tagNameArray.forEach((name, index) => {
                tags.push({
                    name,
                    color: tagColors[index],
                    // use default type
                    type: FieldType.String,
                    format: FieldFormat.NotSpecified,
                } as ITag);
            });
            if (project.tags) {
                await this.addMissingTags(project, tags);
            } else {
                project.tags = tags;
            }
        } catch (err) {
            // ignore err
        }
    }

    /**
     * Assign project tags
     * A new project does not have any tags at the beginning. But it could connect to a blob container
     * Which contains existing fields .json file. In this case, we'll populate project tags base on this file.
     * @param project the project we're trying to create
     * @param storageProvider the storage we're trying to save the project to
     */

    private async getTagsFromPreExistingFieldFile(project: IProject, storageProvider: IStorageProvider) {
        const fieldFilePath = joinPath("/", project.folderPath, constants.fieldsFileName);
        try {
            const json = await storageProvider.readText(fieldFilePath, true);
            const fieldInfo = JSON.parse(json) as IFieldInfo;
            const tags: ITag[] = [];
            fieldInfo.fields.forEach((field, index) => {
                // if (!field.fieldTableFormat) {
                tags.push({
                    name: field.fieldKey,
                    color: tagColors[index],
                    columnTagName: field.columnTagName,
                    tableFormat: field.fieldTableFormat,
                    type: field.fieldType,
                    format: field.fieldFormat,
                } as ITag);
            // }
            });
            if (project.tags) {
                project.tags = patch(project.tags, tags, "name", ["type", "format"]);
                await this.addMissingTags(project, tags);
            } else {
                project.tags = tags;
            }
            project.cvProjId = fieldInfo.cvProjId?fieldInfo.cvProjId:"";
            project.cvProjName = fieldInfo.cvProjName?fieldInfo.cvProjName:"";;

            toast.dismiss();
        } catch (err) {
            if (err instanceof SyntaxError) {
                const reason = interpolate(strings.errors.invalidJSONFormat.message, {fieldFilePath});
                toast.error(reason, {autoClose: false});
            }
        }
    }

    private async setColorsForUpdatedTags(oldProject: IProject, updatedProject: IProject) {
        if (!oldProject.tags || oldProject.tags.length === 0) {
            return;
        }

        let existingTags: ITag[] = [];
        const newTags: ITag[] = [];
        updatedProject.tags.forEach((updatedTag) => {
            if (!oldProject.tags.find((oldTag) => updatedTag.name === oldTag.name)) {
                newTags.push(updatedTag);
            } else {
                existingTags.push(updatedTag);
            }
        });
        existingTags = patch(existingTags, oldProject.tags, "name", ["color"]);
        newTags.forEach((newTag) => {
            newTag.color = getNextColor(existingTags);
            existingTags.push(newTag);
        });
        updatedProject.tags = existingTags;
    }

    private async addMissingTags(project: IProject, tags: ITag[]) {
        const missingTags = tags.filter((fileTag) => !project.tags.find((tag) => fileTag.name === tag.name));
        project.tags = [...project.tags, ...missingTags];
    }

    /**
     * Save fields.json
     * @param project the project we're trying to create
     * @param storageProvider the storage we're trying to save the project
     */
    private async saveFieldsFile(project: IProject, storageProvider: IStorageProvider) {
        Guard.null(project);
        Guard.null(project.tags);

        const fieldInfo = {
            fields: project.tags.map((tag) => ({
                fieldKey: tag.name,
                fieldType: tag.type ? tag.type : FieldType.String,
                fieldTableFormat: tag.tableFormat,
                columnTagName: tag.columnTagName,
                fieldFormat: tag.format ? tag.format : FieldFormat.NotSpecified,
            } as IField)),
            cvProjId:project.cvProjId,  
            cvProjName:project.cvProjName,    
        };

        const fieldFilePath = joinPath("/", project.folderPath, constants.fieldsFileName);
        await storageProvider.writeText(fieldFilePath, JSON.stringify(fieldInfo, null, 4));
    }

    
    public async updatedAssetMetadata(project: IProject,  assetDocumentCountDifference: any): Promise<IProject> {
        const updatedProject = Object.assign({}, project);
        const tags: ITag[] = [];
        updatedProject.tags.forEach((tag) => {
            const diff = assetDocumentCountDifference[tag.name];
            if (diff) {
                tags.push({
                    ...tag,
                    documentCount: tag.documentCount + diff,
                } as ITag);
            } else {
                tags.push({
                    ...tag,
                } as ITag);
            }
        });
        updatedProject.tags = tags;
        if (JSON.stringify(updatedProject.tags) === JSON.stringify(project.tags)) {
            return project;
        } else {
            return updatedProject;
        }
    }

     /**
     * Ensures backwards compatibility with project
     * @param project The project to update
     */
    private ensureBackwardsCompatibility(project: IProject) {
        const projectVersion = project.version.toLowerCase();

        if (projectVersion.startsWith("2.0.0")) {
            // Required for backwards compatibility with v2.0.0 release
            if (project.exportFormat.providerType === "tensorFlowPascalVOC") {
                project.exportFormat.providerType = "pascalVOC";
            }
        }
    }


}
